
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $fc04fcbbc30d2282$exports = {};

$parcel$export($fc04fcbbc30d2282$exports, "frame", () => $fc04fcbbc30d2282$export$2cef06c20297c17d, (v) => $fc04fcbbc30d2282$export$2cef06c20297c17d = v);
var $fc04fcbbc30d2282$export$2cef06c20297c17d;
$fc04fcbbc30d2282$export$2cef06c20297c17d = `izRdzq_frame`;


//# sourceMappingURL=frame.module.7d272bc2.js.map
